import { useMutation } from '@tanstack/react-query';
import { deleteStarredDocument } from 'services/documentService';

import { error as renderError } from 'helpers/toaster';

const useDeleteStarredDocument = () => {
  return useMutation({
    mutationFn: deleteStarredDocument,
    onError: (error) => {
      renderError(error);
    },
  });
};

export default useDeleteStarredDocument;
